import { DesktopTimePicker } from '@mui/x-date-pickers-pro';
import { memo } from 'react';
import { TimePickerInterface } from './interface';

const BluTimePicker = memo(function BluTimePicker({
  value,
  onChange,
  format = 'HH:mm',
  textField,
  locale = 'it',
  placeholder = 'HH:MM',
  ...rest
}: TimePickerInterface) {
  return (
    <DesktopTimePicker
      format={format}
      value={value}
      onChange={onChange}
      {...rest}
      slotProps={{
        ...rest.slotProps,
        textField: {
          variant: 'standard',
          size: 'small',
          fullWidth: false,
          ...rest?.slotProps?.textField,

          // sx: {
          // width: 'unset',
          // marginTop: '0px !important',
          // fontWeight: 'bold',
          // boxSizing: 'border-box',
          // '& .MuiPickersInputBase-root': {
          //   marginTop: '0px !important',
          //   border: '1px solid var(--input-border-color)',
          //   borderRadius: '4px',
          // },

          // '& .MuiPickersInputBase-root::before': {
          //   opacity: '0',
          // },

          // '& input::placeholder': {
          //   fontWeight: 400,
          //   fontStyle: 'italic',
          // },
          // '& .MuiInput-root': {
          //   paddingTop: 0,
          //   paddingBottom: 0,
          //   paddingLeft: '5px',
          //   paddingRight: '0px',
          //   // borderColor: 'var(--input-border-color) !important',
          // },
          // '& .MuiInput-input': {
          //   padding: '0px',
          // },
          // '& .Mui-disabled': {
          //   color: 'rgba(0, 0, 0, 0.38)',
          // },
          // '& .MuiPickersInputBase-sectionsContainer': {
          //   fontWeight: 'bold',
          //   paddingLeft: '5px',
          //   paddingBottom: '0px',
          // },
          //   ...rest?.slotProps?.textField?.sx,
          // },
        },
      }}
      enableAccessibleFieldDOMStructure={rest?.slots?.textField === undefined}
    />
  );
});

export default BluTimePicker;
